import * as Yup from 'yup';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { MdPeople } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';

interface MaxCapacityModalProps {
  initialValues: { maxCapacity: number };
  onClose: () => void;
  onSave: (maxCapacity: number) => void;
}

const MaxCapacityModal: React.FC<MaxCapacityModalProps> = ({
  initialValues,
  onClose,
  onSave
}) => {
  const { t } = useTranslation(['events']);

  const MaxCapacitySchema = Yup.object().shape({
    maxCapacity: Yup.string()
      .required('Required field')
      .matches(/^\d+$/, 'Must be a valid number')
      .test(
        'min',
        'must be greater than or equal to 1',
        (value) => !value || parseInt(value, 10) >= 1
      )
  });

  return (
    <Formik
      initialValues={{ maxCapacity: initialValues.maxCapacity.toString() }}
      onSubmit={(values) => {
        onSave(parseInt(values.maxCapacity, 10));
        onClose();
      }}
      enableReinitialize
      validationSchema={MaxCapacitySchema}
    >
      {({ submitForm }) => (
        <Modal
          type={ModalType.SMALL}
          onClose={onClose}
          autoHeight
          visible
          icon={<MdPeople size={20} />}
          title={t('events:settings.maxCapacity.modal.title')}
          renderFooter={() => (
            <Button type={ButtonType.Primary} onClick={submitForm}>
              {t('events:settings.maxCapacity.modal.saveButton')}
            </Button>
          )}
        >
          <div className="px-4 pt-6">
            <Field
              type="text"
              label={t('events:settings.maxCapacity.modal.maxCapacityLabel')}
              id="maxCapacity"
              name="maxCapacity"
              clearable
              placeholder={t(
                'events:settings.maxCapacity.modal.maxCapacityPlaceholder'
              )}
            />
          </div>
        </Modal>
      )}
    </Formik>
  );
};

export default MaxCapacityModal;
